import { ApiClientBase } from '../base/api-client-base.ts';
import Endpoints from '../endpoints';
import type {
  ITradingApi,
  GetLatestRoundParams,
  GetLatestRoundResponse,
  GetPortfolioResponse,
  GetPerformanceResponse,
  GetAgentPerformanceParams,
  GetAgentPerformanceResponse,
} from '@/services/api';

export class TradingApi extends ApiClientBase implements ITradingApi {
  public readonly getLatestRound = async (
    params?: GetLatestRoundParams
  ): Promise<GetLatestRoundResponse['data']> => {
    const url = Endpoints.Trading.getLatestRound();
    const response = await this.asyncRunner(() =>
      this.api.get<GetLatestRoundResponse>(url, {
        params: {
          includeMessages: true,
          ...params,
        },
      })
    );
    return response.data.data;
  };

  public readonly getPortfolio = async (): Promise<GetPortfolioResponse['data']> => {
    const url = Endpoints.Trading.getPortfolio();
    const response = await this.asyncRunner(() =>
      this.api.get<GetPortfolioResponse>(url)
    );
    return response.data.data;
  };

  public readonly getPerformance = async (): Promise<GetPerformanceResponse['data']> => {
    const url = Endpoints.Trading.getPerformance();
    const response = await this.asyncRunner(() =>
      this.api.get<GetPerformanceResponse>(url)
    );
    return response.data.data;
  };

  public readonly getAgentPerformance = async (
    params?: GetAgentPerformanceParams
  ): Promise<GetAgentPerformanceResponse['data']> => {
    const url = Endpoints.Trading.getAgentPerformance();
    const response = await this.asyncRunner(() =>
      this.api.get<GetAgentPerformanceResponse>(url, { params })
    );
    return response.data.data;
  };
}
